import React, { useState } from 'react';
import './Contato.css';

const Contato = () => {
  const [formData, setFormData] = useState({
    nome: '',
    email: '',
    telefone: '',
    mensagem: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert('Mensagem enviada com sucesso! Entraremos em contato em breve.');
    setFormData({
      nome: '',
      email: '',
      telefone: '',
      mensagem: ''
    });
  };

  return (
    <section id="contato" className="section contato">
      <div className="container">
        <span className="section-eyebrow">Contato</span>
        <h2 className="section-title">Entre em Contato</h2>
        <p className="section-subtitle contato-descricao">Tem dúvidas ou quer saber mais sobre nossa solução? Fale conosco!</p>
        
        <div className="contato-container">
          <div className="contato-info">
            <div className="contato-item">
              <i className="fas fa-phone"></i>
              <div>
                <h3>Telefone</h3>
                <p>(86) 99482-2589</p>
              </div>
            </div>
            
            <div className="contato-item">
              <i className="fas fa-envelope"></i>
              <div>
                <h3>E-mail</h3>
                <p>agrovacina@gmail.com</p>
              </div>
            </div>
            
            <div className="contato-item">
              <i className="fas fa-map-marker-alt"></i>
              <div>
                <h3>Localização</h3>
                <p>Maranhão, Brasil</p>
              </div>
            </div>
            
            <div className="redes-sociais">
              <h3>Siga-nos</h3>
              <div className="social-icons">
                <a href="https://www.instagram.com/agrovacina/" className="social-icon" target="_blank" rel="noopener noreferrer">
                  <i className="fab fa-instagram"></i>
                </a>
              </div>
            </div>
          </div>
          
          <div className="contato-form">
            <h3>Envie uma mensagem</h3>
            <form id="form-contato" onSubmit={handleSubmit}>
              <div className="form-group">
                <input 
                  type="text" 
                  id="nome" 
                  name="nome" 
                  placeholder="Seu nome" 
                  value={formData.nome}
                  onChange={handleChange}
                  required 
                />
              </div>
              <div className="form-group">
                <input 
                  type="email" 
                  id="email" 
                  name="email" 
                  placeholder="Seu e-mail" 
                  value={formData.email}
                  onChange={handleChange}
                  required 
                />
              </div>
              <div className="form-group">
                <input 
                  type="tel" 
                  id="telefone" 
                  name="telefone" 
                  placeholder="Seu telefone" 
                  value={formData.telefone}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <textarea 
                  id="mensagem" 
                  name="mensagem" 
                  placeholder="Sua mensagem" 
                  rows="5" 
                  value={formData.mensagem}
                  onChange={handleChange}
                  required 
                ></textarea>
              </div>
              <button type="submit" className="btn btn-enviar">Enviar Mensagem</button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contato;